import * as React from "react";
import { SVGProps } from "react";

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 3.128L10.8941 2.02341L7.01175 5.90123L3.10592 2L2 3.10457L5.90583 7.0058L2.01175 10.8954L3.11764 12L7.01175 8.11042L10.8941 11.9882L12 10.8836L8.11764 7.0058L12 3.128Z"
      fill="#485359"
    />
  </svg>
);
export default SVGComponent;
